import { ChangeDetectionStrategy, Component, output } from '@angular/core';
import { CabinetHomeTasksSummaryComponent } from './cabinet-home-tasks-summary.component';
import type { CabinetHomeViewMode } from './cabinet-home-getting-started.util';

/** @deprecated Use CabinetHomeTasksSummaryComponent. */
@Component({
  selector: 'lib-cabinet-home-getting-started',
  imports: [CabinetHomeTasksSummaryComponent],
  template: `
    <lib-cabinet-home-tasks-summary (viewModeChange)="viewModeChange.emit($event)" />
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CabinetHomeGettingStartedComponent {
  readonly viewModeChange = output<CabinetHomeViewMode>();
}
